<template>
  <v-chip label small :color="getStartTimeColor()" :text-color="getStartTimeTextColor()">{{ prepend }} {{ toStart }} {{ append }} </v-chip>
</template>

<script>
import { countdown, countdownObject } from '../common/methods'
import { parseISO, getUnixTime } from 'date-fns'

export default {
  name: 'Countdown',
  props: {
    startTime: String,
    styles: String,
    prepend: String,
    append: String
  },
  methods: {
    countdown,
    getStartTimeColor () {
      const start = countdown(getUnixTime(parseISO(this.startTime)))
      if (start.includes('h')) return '#DBDEE3'
      if (start.includes('-')) return 'red'
      if (start.includes('d')) return '#DBDEE3'
      return 'blue'
    },
    getStartTimeTextColor(){
      const start = countdown(getUnixTime(parseISO(this.startTime)))
      if (start.includes('h')) return 'black'
      if (start.includes('d')) return 'black'
      return 'white'
    },
    createInterval (length) {
      clearInterval(this.interval)
      this.interval = setInterval(() => {
        this.toStart = countdown(getUnixTime(parseISO(this.startTime)))
      }, length)
    },
    visibilityChanged (isVisible) {
      if (isVisible) {
        this.start()
        return
      }
      this.stop()
    },
    start () {
      const time = getUnixTime(parseISO(this.startTime))
      const timeObj = countdownObject(time)
      if (timeObj.minutes >= 5) {
        this.interval = setInterval(() => {
          const currentTime = countdownObject(getUnixTime(parseISO(this.startTime)))
          if (currentTime.hours === 0 && currentTime.minutes < 5) {
            this.createInterval(500)
          }
          this.toStart = countdown(time)
        }, 30000)
      } else {
        this.createInterval(1000)
      }
    },
    stop () {
      clearInterval(this.interval)
    }
  },
  data () {
    return {
      toStart: countdown(getUnixTime(parseISO(this.startTime))),
      interval: null
    }
  },
  mounted () {
    this.start()
  },
  beforeDestroy () {
    this.stop()
  }
}
</script>
